import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { GroupLayout } from '@cld/form';
import { messages } from '../../../../i18n';
import { TextLine } from '../../common/TextLine';
import { ResizeAndCropOptionField } from './ResizeAndCropOptionField';

const Root = styled.div`
  margin-top: ${globalTheme.spacing.lg}
`;

export const FlipAndRotate: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Root>
      <TextLine>
        <FormattedMessage {...messages['section.resizeAndCrop.flipAndRotate']} />
      </TextLine>
      <GroupLayout>
        <ResizeAndCropOptionField
          label={formatMessage(messages['section.resizeAndCrop.flipAndRotate.flip'])}
          optionPath="flip"
        />
        <ResizeAndCropOptionField
          label={formatMessage(messages['section.resizeAndCrop.flipAndRotate.rotate'])}
          optionPath="rotate"
        />
      </GroupLayout>
    </Root>
  );
};
